import React from 'react'
import PropTypes from 'prop-types'

// Components
import Text from 'ui/Text'
import Row from 'ui/Row'
import Col from 'ui/Col'
import ButtonDownload from 'ui/ButtonDownload'
import DateRange from 'ui/DateRange'
import ButtonReset from 'ui/ButtonReset'
import SelectPaymentStatus from 'components/Payment/SelectPaymentStatus'
import SelectPaymentMethod from 'components/Payment/SelectPaymentMethod'

export const defaultFilters = {
  status: '',
  postingDate: [],
  paymentMethod: '',
  selected: [],
  mode: '',
}

function PaymentTrackerFilters({
  filters,
  onFiltersChange,
  onDownloadClick,
  showDownloadButton,
  loading,
}) {
  const onDateChange = (newValue) => {
    onFiltersChange({
      ...filters,
      postingDate: newValue,
    })
  }

  const onStatusChange = (newValue) => {
    onFiltersChange({
      ...filters,
      status: newValue,
    })
  }

  const onMethodChange = (newValue) => {
    onFiltersChange({
      ...filters,
      paymentMethod: newValue,
    })
  }

  const onResetClick = () => {
    onFiltersChange(defaultFilters)
  }

  return (
    <div style={{ marginBottom: '1rem' }}>
      <Row multiline>
        <Col md={9}>
          <Row multiline>
            <Col sm={{ span: 12 }} md={{ narrow: true, vcenter: true }}>
              <Text paddingTop={5} paddingBottom={5}>
                Filter by:
              </Text>
            </Col>
            <Col sm={{ span: 4 }} md={{ span: 'auto' }}>
              <DateRange
                value={filters.postingDate}
                placeholder="Posting date range"
                onChange={onDateChange}
              />
            </Col>
            <Col sm={{ span: 4 }} md={{ span: 'auto' }}>
              <SelectPaymentMethod
                value={filters.paymentMethod}
                onChange={onMethodChange}
              />
            </Col>
            <Col sm={{ span: 4 }} md={{ span: 'auto' }}>
              <SelectPaymentStatus
                value={filters.status}
                onChange={onStatusChange}
              />
            </Col>
            <Col sm={{ narrow: true, vcenter: true }}>
              <ButtonReset
                onClick={onResetClick}
                style={{ justifyContent: 'flex-start' }}
              ></ButtonReset>
            </Col>
          </Row>
        </Col>

        <Col
          md={{ span: 3 }}
          className="d-flex align-items-center justify-content-sm-start justify-content-md-end"
        >
          {showDownloadButton && (
            <ButtonDownload
              loading={loading}
              extentions={['xlsx', 'csv']}
              onClick={onDownloadClick}
            >
              Download list
            </ButtonDownload>
          )}
        </Col>
      </Row>
    </div>
  )
}

PaymentTrackerFilters.propTypes = {
  filters: PropTypes.shape({
    status: PropTypes.string,
    postingDate: PropTypes.array,
    paymentMethod: PropTypes.string,
    selected: PropTypes.array,
    mode: PropTypes.string,
  }),
  onFiltersChange: PropTypes.func,
  onDownloadClick: PropTypes.func,
  showDownloadButton: PropTypes.bool,
  loading: PropTypes.bool,
}

PaymentTrackerFilters.defaultProps = {
  filters: {},
  onFiltersChange: () => {},
  onDownloadClick: () => {},
  showDownloadButton: false,
  loading: false,
}

export default PaymentTrackerFilters
